<template>
  <div class="wrapper">
    <div class="header">
      <div class="left">
<!--        <img src="../assets/icon-jiantou.png" alt />-->
        <p>找回密码</p>
      </div>
    </div>
    <div class="content" style="margin-top:80px">
      <div class="input-box">
        <span>新密码</span>
        <input
          class="password"
          placeholder="8-16字符,需包含大小写字母"
          v-model="new_password1"
          type="password"
          maxlength="16"
          @blur="newpass()"
        />
      </div>
      <div class="input-box">
        <span>确认新密码</span>
        <input
          class="password"
          placeholder="请再次输入新密码"
          v-model="new_password2"
          type="password"
          maxlength="16"
        />
      </div>
      <div id="loginbtn" class="loginbtn1" v-on:click="complete()">完成</div>
    </div>
  </div>
</template>

<script>

// 引入
import { Toast } from 'mint-ui'

export default {
  data () {
    return {
      phone: '',
      new_password1: '',
      new_password2: '',
      password: '',
      url: ''
    }
  },
  created () {
    this.get()
  },
  methods: {
    get () {
      this.url = window.location.href
      this.url = this.url.split('?')
      this.phone = this.url[1]
    },
    newpass () {
      var word = this.new_password1.trim()
      var word1 = this.new_password1.trim()
      if (word.length === 0) {
        return Toast('密码不能为空!')
      } else if (word.length < 8) {
        return Toast('密码的最小长度不能少于8位')
      }
      if (word1.length === 0) {
        return Toast('密码不能为空!')
      } else if (word1.length < 8) {
        return Toast('密码的最小长度不能少于8位')
      }
      // var count = 0 // 密码等级
      // if (/[0-9]/.test(word)) {
      //   count++
      // }
      // if (/[A-Za-z]/.test(word)) {
      //   count++
      // }
      // if (/[^0-9A-Za-z]/.test(word)) {
      //   count++
      // }
      // if (count == 3 && word.length >= 6) {
      //   this.msgpassword = '高强度'
      // } else if (count == 2 && word.length >= 6) {
      //   this.msgpassword = '中强度'
      // } else {
      //   this.msgpassword = '低强度'
      // }
      // return word >= 0
    },
    complete () {
      if (this.new_password1.length < 8 && this.new_password2.length < 8) {
        Toast('密码为数不能低于8位')
        return false
      }
      if (!/([a-zA-Z]+[0-9]+|[0-9]+[a-zA-Z])/.exec(this.new_password1) && !/([a-zA-Z]+[0-9]+|[0-9]+[a-zA-Z])/.exec(this.new_password2)) {
        Toast('密码必须包含大小写字母')
        return false
      }
      if (this.new_password2 !== this.new_password1) {
        Toast('两次输入的密码不同，请重新输入')
        return false
      }
      var _this = this
      if (this.new_password1 === this.new_password2) {
        this.password = this.new_password1
        this.utils.POST(this.accountUrl + '/account/retrieve', { phone: this.phone, new_password1: this.new_password1, new_password2: this.new_password2, password: this.password }, (res) => {
          Toast('修改密码成功!')
          _this.$router.go(-2)
        })
      }
    }
  }
}
</script>

<style scoped>
.wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: #fff;
}
.wrapper .content {
  background-color: #ffffff;
  /*background-color: yellow;*/
}
.content .input-box {
  position: relative;
  line-height: 54px;
  z-index: 100;
  border-bottom: solid #eeeeee 1px;
  box-sizing: border-box;
  /*background-color: yellow;*/
}
.content .input-box span {
  position: absolute;
  font-size: 15px;
  color: #000000;
}
.content .input-box input {
  height: 53px;
  width: calc(100% - 80px);
  line-height: 53px;
  font-size: 15px;
  color: #000000;
  border: none;
  padding: 15px 0 15px 100px;
  line-height: 24px;
}
.content .input-box input.code {
  width: calc(100% - 160px);
}
.content .input-box .button {
  position: absolute;
  right: 20px;
  top: 163px;
  width: 80px;
  line-height: 40px;
  text-align: right;
  background-color: #fecdcd;
  border-radius: 20px;
  color: #ffffff;
}
.wrapper .loginbtn {
  margin-top: 50px;
  line-height: 40px;
  background-color: #fecdcd;
  text-align: center;
  color: #ffffff;
  font-size: 15px;
  border-radius: 20px;
}
.wrapper .loginbtn1 {
  margin-top: 50px;
  line-height: 40px;
  background-color: #c41335;
  text-align: center;
  color: #ffffff;
  font-size: 15px;
  border-radius: 20px;
}
.login .footer {
  z-index: 1000;
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 110px;
}
.left {
  float: left;
}
.right {
  float: right;
  margin-top: 5px;
  padding-right: 20px;
}
.header {
  position: relative;
  margin-top: 30px;
}
.left img {
  position: absolute;
  top: 5px;
  left: 10px;
  width: 18px;
}
.left p {
  position: absolute;
  top: 0;
  left: 35px;
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/back-Pwd.vue